@if(countdown > 0) {
  <span>Seu token expira em: <strong>{{ displayTime }}</strong></span>
} @else {
  <span>Token expirado!</span>
}
